interface FormFieldProps {
  label: string;
  value: string;
  onChange?: (value: string) => void;
  rightElement?: React.ReactNode;
  className?: string;
  readOnly?: boolean;
  type?: "text" | "textarea";
}

const FormField = ({
  label,
  value,
  onChange,
  rightElement,
  type = "text",
  className,
  readOnly = false,
}: FormFieldProps) => {
  return (
    <div
      className={`border-b border-black-6 px-4 py-3 overflow-hidden last:border-b-0 ${className}`}
    >
      <div className="flex items-center justify-between">
        <div className="flex flex-col w-full">
          <label className="text-black-48 text-14">{label}</label>
          {type === "textarea" ? (
            <p className="text-black text-14 focus:outline-none w-full bg-transparent">
              {value}
            </p>
          ) : (
            <input
              type={type}
              value={value}
              onChange={(e) => onChange?.(e.target.value)}
              className=" text-black text-14 focus:outline-none w-full bg-transparent"
              readOnly={readOnly}
            />
          )}
        </div>
        {rightElement}
      </div>
    </div>
  );
};

export default FormField;
